import { schema } from 'normalizr'

export const hostSchema = new schema.Entity(
  'hosts',
  {},
  {
    idAttribute: 'id',
  }
)
